import { Link } from "react-router-dom";
import {
  FaGithub,
  FaLinkedinIn,
  FaXTwitter,
  FaFacebookF,
  FaInstagram,
  FaSoundcloud,
} from "react-icons/fa6";
import { SOCIALS } from "../data/socials";
import Footer from "../components/Footer";

const ICONS = {
  github: FaGithub,
  linkedin: FaLinkedinIn,
  x: FaXTwitter,
  facebook: FaFacebookF,
  instagram: FaInstagram,
  soundcloud: FaSoundcloud,
};

const ArrowUpRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M7 17L17 7M17 7H8M17 7V16" />
  </svg>
);

function Linktree() {
  return (
    <>
      <main className="linktree section" id="links">
        <div className="wrap">
          <Link to="/" className="lt-back reveal">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Back to portfolio
          </Link>

          <span className="kicker reveal" data-d="1">Connect</span>
          <h1 className="lt-title reveal" data-d="2">
            Find me
            <br />
            <em>elsewhere.</em>
          </h1>
          <p className="lt-intro reveal" data-d="3">
            Every place I show up online — code, conversation and the occasional sound.
          </p>

          <ul className="lt-list reveal" data-d="4">
            {SOCIALS.map((s) => {
              const Icon = ICONS[s.key];
              return (
                <li key={s.key}>
                  <a
                    className="lt-row"
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`${s.label} — ${s.handle}`}
                  >
                    <span className="lt-icon">{Icon ? <Icon /> : null}</span>
                    <span className="lt-text">
                      <span className="lt-label">{s.label}</span>
                      <span className="lt-handle">{s.handle}</span>
                    </span>
                    <span className="lt-arrow">
                      <ArrowUpRight />
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Linktree;
